import { CognitoUserSession } from 'amazon-cognito-identity-js'

import {
  BaseSubjectStore,
  IAuthConfigOptions,
  IAuthResponse,
  ISiteConfiguration,
  LoginTypes,
} from '@procom-labs/common'

import { IUserAttributes, IUserSocialSession } from '@auth-portal/types'

interface AuthStoreState {
  authConfigOptions: IAuthConfigOptions | null
  currentCognitoUserEmail: string
  currentCognitoUserPassword: string
  currentOtpUser: IAuthResponse | null
  currentUserSession: CognitoUserSession | null
  currentUserSocialSession: IUserSocialSession | null
  isCognitoUserSessionExpired: boolean
  isMfaCodeRequested: boolean
  loginType: LoginTypes | null
  siteConfig: ISiteConfiguration | null
  userAttribute: IUserAttributes | null
}

class AuthStore extends BaseSubjectStore<AuthStoreState> {
  getDefaultValue(): Required<AuthStoreState> {
    return {
      currentCognitoUserEmail: '',
      currentCognitoUserPassword: '',
      currentOtpUser: null,
      currentUserSession: null,
      currentUserSocialSession: null,
      isCognitoUserSessionExpired: false,
      isMfaCodeRequested: false,
      loginType: null,
      siteConfig: null,
      authConfigOptions: null,
      userAttribute: null,
    }
  }

  setSiteConfig(data: ISiteConfiguration): void {
    this.dispatch({
      siteConfig: data,
    })
  }

  setAuthConfigOptions(options: IAuthConfigOptions): void {
    this.dispatch({
      authConfigOptions: options,
    })
  }

  setCurrentCognitoUserEmail(email: string): void {
    this.dispatch({
      currentCognitoUserEmail: email,
    })
  }

  setCurrentCognitoUserPassword(password: string): void {
    this.dispatch({
      currentCognitoUserPassword: password,
    })
  }

  setUserAttributes(attributes: IUserAttributes): void {
    this.dispatch({
      userAttribute: attributes,
    })
  }

  setCognitoUserSession(isSessionExpired: boolean): void {
    this.dispatch({
      isCognitoUserSessionExpired: isSessionExpired,
    })
  }

  setIsMfaCodeRequested(isRequested: boolean): void {
    this.dispatch({
      isMfaCodeRequested: isRequested,
    })
  }

  setCurrentUserSocialSession(session: IUserSocialSession | null): void {
    this.dispatch({
      currentUserSocialSession: session,
    })
  }

  setCurrentUserSession(session: CognitoUserSession | null): void {
    this.dispatch({
      currentUserSession: session,
    })
  }

  setCurrentOtpUser(user: IAuthResponse | null): void {
    this.dispatch({
      currentOtpUser: user,
    })
  }

  updateState(updatedState: Partial<AuthStoreState>): void {
    this.dispatch({
      ...updatedState,
    })
  }
}

export const authStore = new AuthStore()
